import { OrderInvoiceType } from '@lambda/apis/src/order/types';

/**
 * Kept free of runtime dependencies: the storefront imports this into the
 * browser bundle, unlike its server-only siblings in ./invoiceRequests.
 *
 * Concatenated and never split — a vendor name may itself contain "#".
 */
export const invoiceRequestKey = ({
  orderId,
  vendorId,
  type,
}: {
  orderId: string;
  vendorId: string;
  type: OrderInvoiceType;
}) => `${orderId}#${vendorId}#${type}`;

/** Only pending requests are collected, so presence means "still outstanding". */
export type InvoiceRequestByOrderVendor = Record<
  string,
  { requestedAt: string; dueAt: string }
>;
